export const Logo = ({ className = "" }) => (
  <svg width="36" height="36" viewBox="0 0 36 36" aria-hidden="true" className={`dr shrink-0 ${className}`}>
    <path d="M4 10q14-6 14 4q0-10 14-4v18q-14-6-14 4q0-10-14-4z" fill="none" stroke="#1f6f70" strokeWidth="2.2" pathLength="1" />
    <circle cx="18" cy="6" r="2.5" fill="#a77b3c" />
  </svg>
);

const PATHS = {
  square: <rect x="3" y="6" width="22" height="16" fill="none" stroke="currentColor" strokeWidth="2" />,
  page: <path d="M6 4h12l4 4v16H6z" fill="none" stroke="currentColor" strokeWidth="2" />,
  triangle: <path d="M4 22l10-16 10 16z" fill="none" stroke="currentColor" strokeWidth="2" />,
  circle: <circle cx="14" cy="14" r="10" fill="none" stroke="currentColor" strokeWidth="2" />,
  wave: <path d="M4 14q5-8 10 0t10 0" fill="none" stroke="currentColor" strokeWidth="2" />,
  hand: <path d="M9 24V12m0 0V6m0 6h4V5m0 7h4V6m0 6h3v6a6 6 0 0 1-6 6H9" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />,
};

export const ServiceIcon = ({ name }) => (
  <svg width="28" height="28" viewBox="0 0 28 28" aria-hidden="true" className="text-teal shrink-0 mt-1">
    {PATHS[name]}
  </svg>
);
